import React, { useState, useEffect, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useLocation } from 'react-router-dom';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, GRID_CHECKBOX_SELECTION_COL_DEF, GridFooter } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { BsPersonSquare } from 'react-icons/bs';
import { formatPhone } from '../../common/utils';
import { ToastContainer } from 'react-toastify';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import RenameList from '../../components/Modals/RenameList';
import { ModalCtx } from '../../contexts';
import { removeItemsFromList } from '../../common/api';
import { toast } from 'react-toastify';
import BorrowerNamesInGrid from '../../containers/Loans/BorrowerNamesInGrid';
import { singleSelectQuickFilter } from '../../common/utils';




import "react-toastify/dist/ReactToastify.css";


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const toolbar = ( { selectedRows, handleModal, hasTxting, hasPhoneBurner, canExport, listType, viewing } ) => {
    return (
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                {
                                                    viewing.length > 1 ? (
                                                        <Dropdown.Item disabled={true}>*** Some Actions Only Available While Viewing Single Account</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                {
                                                        <>
                                                            <Dropdown.Item onClick={ () => handleModal( 'email-mass' ) } disabled={viewing.length !== 1}>Send Mass Email</Dropdown.Item>
                                                            {
                                                                hasTxting ? (
                                                                    <Dropdown.Item onClick={ () => handleModal( 'sms-mass' ) } disabled={viewing.length !== 1}>Send Mass Txt</Dropdown.Item>
                                                                ) : (
                                                                    null
                                                                )
                                                            }
                                                            <Dropdown.Divider />
                                                        </>
                                                }
                                                {
                                                    hasPhoneBurner ? (
                                                        <Dropdown.Item onClick={ () => handleModal( 'phoneburner' ) }>Launch PhoneBurner</Dropdown.Item>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                                <Dropdown.Item onClick={ () => handleModal( 'list' ) } disabled={viewing.length !== 1}>Add to a List</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleModal( 'event' ) } disabled={viewing.length !== 1}>Add to an Event</Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item onClick={ () => handleModal( 'delete' ) }>Remove from this List</Dropdown.Item>
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                    {
                        ( canExport ) ? (
                            <Col xs='auto' className='pe-3 text-right'>
                                <GridToolbarExport />
                            </Col>
                        ) : (
                            null
                        )
                    }
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const List = ( { uid, user, grids, viewing, canExport, stack, lists, contacts, loans } ) => {
    let params = useParams();
    const [ gridHeight, setGridHeight ] = useState( 0 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState( <Fragment /> );
    const [ name, setName ] = useState( '' );
    const [ members, setMembers ] = useState( [] );
    const [ listType, setListType ] = useState( '' );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ aid, setAid ] = useState( null );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ hasUnsavedRows, setHasUnsavedRows ] = useState( false );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ singleSaveId, setSingleSaveId ] = useState( '' );
    const [ isDiscarding, setIsDiscarding ] = useState( false );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );
    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const query = useQuery();

    const formatName = ( cid ) => {
        const r = contacts[cid];
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const visibleCols = {
      description: false,
      ownerId: false
    };
  
    const gridHelpers = {
        valueGetter: {
            contact: ( { row } ) => {
                return formatName( row.cid );
            },
            referralContact: ( { row } ) => {
                return formatName( row.referredById );
            },
            partner: ( { row } ) => {
                let n = '';
                const c = contacts[row.cid];
                if ( c && c.firstnamePartner1 ) {
                    n = c.firstnamePartner1;
                    if ( c.lastnamePartner1 ) {
                        if ( n.length ) {
                            n += ' ';
                        }
                        n += c.lastnamePartner1;
                    }
                }
                return n;
            },
            phone: ( { row } ) => {
                let p;  
                const c = contacts[row.cid];
                if ( c && c.phoneMobile && c.phoneMobile.length ) {
                    p = c.phoneMobile;
                } else if ( c && c.phone && c.phone.length ) {
                    p = c.phone;
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            borrowers: ( params ) => {
                let v = [];
                if ( params.row.borrowers ) {
                    params.row.borrowers.forEach( b => {
                        const c = contacts[b.cid];
                        if ( c ) {
                            v.push( c.name );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.phoneMobile && c.phoneMobile.length ) {
                            p = c.phoneMobile;
                        } else if ( c && c.phone && c.phone.length ) {
                            p = c.phone;
                        }
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.email && c.email.length ) {
                            e = c.email;
                        }
                    }
                }
                return ( e ) ? e : null;
            },
            nameBA: ( { row } ) => {
                let n;
                if ( row.baId ) {
                    n = formatName( row.baId );
                }
                return ( n ) ? n : null;
            },
            nameLA: ( { row } ) => {
                let n;
                if ( row.laId ) {
                    n = formatName( row.laId );
                }
                return ( n ) ? n : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            ooeBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutEmail ) {
                            oo = c.optoutEmail;
                        }
                    }
                }
                return ( oo );
            },
            oocBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutCall ) {
                            oo = c.optoutCall;
                        }
                    }
                }
                return ( oo );
            },
            oosBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers && row.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.optoutSms ) {
                            oo = c.optoutSms;
                        }
                    }
                }
                return ( oo );
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( ( value.match( 'T' ) ) ? value : value + 'T12:00:00' );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            referralLoan: ( { row } ) => {
                let n;
                const l = loans[row.id];
                if ( l && l.borrowers && l.borrowers.length ) {
                    const pri = row.borrowers.find( f => f.label === 'Primary' ) || row.borrowers[0];
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.referredById ) {
                            n = formatName( c.referredById );
                        }
                    }
                }
                return n;
            },
            rank: ( params ) => {
                let rank;
                if ( params.row.borrowers ) {
                    const pri = params.row.borrowers.find( f => f.label === 'Primary' );
                    if ( pri ) {
                        const c = contacts[pri.cid];
                        if ( c && c.rank ) {
                            rank = c.rank;
                        }
                    }
                }
                return rank;
            },
            rate: ( { value } ) => {
                let d;
                if ( value ) {
                    // Remove any non-numeric characters except for the decimal point and percent sign
                    let cleanedValue = value.toString().replace(/[^0-9.%]+/g, '');

                    // Check if the value contains a percent sign
                    if ( cleanedValue.includes( '%' ) ) {
                        // Remove the percent sign and convert to float, then divide by 100
                        d = parseFloat( cleanedValue.replace( '%', '') );
                    } else {
                        // Convert the cleaned value to float
                        d = parseFloat( cleanedValue );
                    }
                }
                return d;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <BorrowerNamesInGrid row={row} />,
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { row } ) => {
                let l;
                if ( row && row.cid ) {
                    const c = contacts[row.cid];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referral: ( { row } ) => {
                let l;
                if ( row && row.referredById ) {
                    const c = contacts[row.referredById];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            ba: ( { row } ) => {
                let l;
                if ( row && row.baId ) {
                    const c = contacts[row.baId];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            la: ( { row } ) => {
                let l;
                if ( row && row.laId ) {
                    const c = contacts[row.laId];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referralLoan: ( { row } ) => {
                let r;
                const l = loans[row.id];
                if ( l && l.borrowers && l.borrowers.length ) {
                    const c = contacts[l.borrowers[0].cid];
                    if ( c && c.referredById ) {
                        r = <Link to={`/contact/${c.referredById}`}>{ formatName( c.referredById ) }</Link>
                    }
                }
                return r;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                return ( value ) ? value : '';
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            referralLoan: ( { value } ) => {
                return ( value ) ? value : '';
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const list = [];
        const allCids = [];
        const allLids = [];
        const emailCids = [];
        const emailLids = [];
        const phoneCids = [];
        const phoneLids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        
        selectedRows.forEach( iid => {
            const c = contacts[iid];
            if ( c ) {
                list.push( c );
                allCids.push( iid );
                if ( c.email && c.email.length ) {
                    if ( !uniqueEmails.has( c.email.toLowerCase() ) && c.optoutEmail !== true ) {
                        uniqueEmails.add( c.email.toLowerCase() );
                        emailCids.push( iid );
                    }
                }
                let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                if ( p && p.length ) {
                    p = formatPhone( p );
                    if ( !uniquePhones.has( p ) && c.optoutSms !== true ) {
                        uniquePhones.add( p );
                        phoneCids.push( iid );
                    }
                }
            } else {
                const l = loans[iid];
                if ( l.borrowers?.length ) {
                    let seenEmails = false;
                    let seenPhones = false;
                    
                    allLids.push( l.lid );
                                    
                    for ( const b of l.borrowers ) {
                        const c = contacts[b.cid];
                        if ( c ) {
                            if ( c.email ) {
                                if ( uniqueEmails.has( c.email.toLowerCase() ) || c.optoutEmail ) {
                                    seenEmails = true;
                                } else {
                                    uniqueEmails.add( c.email.toLowerCase() );
                                }
                            }
                            let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                            if ( p ) {
                                if ( uniquePhones.has( formatPhone( p ) ) || c.optoutSms ) {
                                    seenPhones = true;
                                } else {
                                    uniquePhones.add( formatPhone( p ) );
                                }
                            }
                        }
                    }
                    
                    if ( !seenEmails ) {
                        emailLids.push( l.lid );
                    }
                    if ( !seenPhones ) {
                        phoneLids.push( l.lid );
                    }
                }
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                if ( listType === 'contacts' ) {
                    setModal( <SendMassEmail close={closeModal} clist={emailCids} objType='contact' aid={viewing[0]} /> );
                } else if ( listType === 'loans' ) {
                    setModal( <SendMassEmail close={closeModal} llist={emailLids} objType='loan' aid={viewing[0]} /> );
                }
                break;
    
            case 'sms-mass':
                if ( listType === 'contacts' ) {
                    setModal( <SendMassTxt close={closeModal} clist={phoneCids} objType='contact' /> );
                } else if ( listType === 'loans' ) {
                    setModal( <SendMassTxt close={closeModal} llist={phoneLids} objType='loan' /> );
                }
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType={listType} items={ ( listType === 'contacts' ) ? allCids : allLids } aid={viewing[0]} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} contacts={list} /> );
                break;

            case 'rename':
                setModal( <RenameList close={closeModal} gid={params.gid} /> );
                break;

            case 'delete':
                await handleAction( t, allCids, allLids );
                shouldOpen = false;
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }
    
    const handleAction = async ( at, cids, lids ) => {
        const l = lists[params.gid];

        switch ( at ) {
            case 'delete':
                const items = [ ...cids, ...lids ];
                console.log( 'Delete ' + items.length + ' items from list ' + params.gid );
                const resp = await removeItemsFromList( l.aid, uid, items, params.gid );
                if ( resp && resp.length ) {
                    toast.success( `Alright, they're off the list!`, { theme: 'dark' } );
                }
                console.log( resp );
                break;

            default:
                console.log( 'Unknown action type: ' + at );
        }
    }

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ aid, uid, params.gid ] );

    useEffect( () => {
        const colLookupMap = {
            contacts: 'listcons',
            loans: 'listloans'
        };
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }
    
        if ( colLookupMap[listType] ) {
            const colLookup = colLookupMap[listType];
            if ( grids && grids[colLookup] && grids[colLookup].cols && !gridReady ) {
                let activeFilter = false;
                setFilterName( '' );
        
                let storedCols = JSON.parse( grids[colLookup].cols );
                if ( filters.fn && grids[colLookup].filters && grids[colLookup].filters[filters.fn] ) {
                    if ( grids[colLookup].filters[filters.fn].cols ) {
                        activeFilter = true;
                        setUsingFilter( true );
                        setFilterName( filters.fn );
                        storedCols = JSON.parse( grids[colLookup].filters[filters.fn].cols );
                    }
        
                    if ( grids[colLookup].filters[filters.fn].criteria ) {
                        const crit = JSON.parse( grids[colLookup].filters[filters.fn].criteria );
                        setFilterModel( { items: crit } );
                    }
        
                    if ( grids[colLookup].filters[filters.fn].className ) {
                        setClassLogic( grids[colLookup].filters[filters.fn].className );
                    }
                } else {
                    if ( filters.crit ) {
                        const crit = JSON.parse( filters.crit );
                        setFilterModel( { items: crit } );
                    }
                    if ( grids[colLookup].className ) {
                        setClassLogic( grids[colLookup].className );
                    }
                }
        
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }
        
                    if ( user && user.datagrids && user.datagrids[colLookup] ) {
                        if ( activeFilter ) {
                            if ( user.datagrids[colLookup].filters && user.datagrids[colLookup].filters[filters.fn] && user.datagrids[colLookup].filters[filters.fn].colSize && user.datagrids[colLookup].filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids[colLookup].filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids[colLookup].colSize && user.datagrids[colLookup].colSize[c.field] ) {
                            c.width = user.datagrids[colLookup].colSize[c.field];
                        }
                    }
        
                    return c;
                } );
                    
                if ( user && user.datagrids && user.datagrids[colLookup] ) {
                    if ( activeFilter ) {
                        if ( user.datagrids[colLookup].filters && user.datagrids[colLookup].filters[filters.fn] && user.datagrids[colLookup].filters[filters.fn].colOrder && user.datagrids[colLookup].filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids[colLookup].filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids[colLookup].colOrder && user.datagrids[colLookup].colOrder.length ) {
                            cols = user.datagrids[colLookup].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }
        
                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, listType, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, query ] );
        
    useEffect( () => {
        if ( lists[params.gid] ) {
            const l = lists[params.gid];

            setAid( l.aid );
            setName( l.label );
            setListType( l.itemType );
            document.title = 'Third Floor - ' + l.label + ' List';

            if ( l.items?.length ) {
                console.log( 'list items: ', l.items );
                let list = [];
                let bucket;
                switch ( l.itemType ) {
                    case 'contacts':
                        bucket = contacts;
                        break;

                    case 'loans':
                        bucket = loans;
                        break;

                    default:
                }

                l.items.forEach( iid => {
                    if ( bucket[iid] ) {
                        list.push( {
                            id: bucket[iid].cid || bucket[iid].lid,
                            ...bucket[iid] 
                        } );
                    }
                } );
                setMembers( list );
            }
        }
    }, [ params.gid, lists, contacts, loans ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: 'calc(100vh - 125px)' } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <BsPersonSquare />
                                        <span className='ps-2 fw-bold fs-6'><span style={ { textTransform: 'capitalize' } }>{listType}</span> in '{name}'</span>
                                    </Col>
                                    <Col className='text-end'>
                                        <Button className='tf-obj-button' size='sm' onClick={ () => handleModal( 'rename' ) }>Rename List</Button>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            initialState={ { 
                                                columns: { columnVisibilityModel: visibleCols },
                                                pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                            } }
                                            // loading={ members.length === 0 }
                                            rows={members}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { 
                                                toolbar: toolbar,
                                                columnMenu: customColumnMenu 
                                            } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleModal: handleModal, 
                                                hasTxting: hasTxting, 
                                                hasPhoneBurner: hasPhoneBurner, 
                                                canExport: canExport,
                                                listType: listType,
                                                viewing: viewing
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                        />
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    lists: state.lists.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( List );